import { EChartType } from '../../../types/charts';
import { NBSP } from '../../../constants/symbols';

export function getCorrectSpace(chartType: EChartType) {
  if (chartType === EChartType.Mortgage) {
    return '';
  }

  return NBSP;
}
